import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderStatusReferenceService extends BaseReferenceService {
  constructor() {
    super('PurchaseOrderStatusReference');
  }
}
